import { NavBar } from '../components';
import {
  Outlet
} from "react-router-dom";
import { useContext, useState, useEffect } from 'react';
import {
  Navigate,
  useLocation
} from "react-router-dom";
import { AppContext } from '../providers/AppContext';
import { useSearchParams } from 'react-router-dom';

export default function App() {
  const [open, setOpen] = useState(false);
  const { setInvitationCode, setShowLogin } = useContext(AppContext);
  const myLocation = useLocation();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('invitationCode');
    if (code) {
      setShowLogin(true);
      setInvitationCode(code);
    }
  }, [searchParams]);

  if (
    !["/home", "/broadside", "/app", "/impact", "/missions"].includes(
      myLocation.pathname
    )
  ) {
    return <Navigate to="/home" />;
  }

  const pagesWithCoverArt = ['/missions'];
  const transparentHeader = pagesWithCoverArt.includes(myLocation.pathname);

  return (
    <>
      <Outlet />
      <div>
        <NavBar navOpen={open} setNavOpen={setOpen} isTransparent={transparentHeader} />
        {/*<FloatingSubscribe />*/}
      </div>
    </>
  );
}
